import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorkOrdersMaterials(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].getWorkOrdersMaterials,
		{
			urlParams: {
				companyId: companyId,
                workOrderId: workOrderId,
			},
		}
	)
}

function getWorkOrdersMaterial(companyId, workOrderId, materialId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].getWorkOrdersMaterial,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                materialId: materialId,
			},
		}
	)
}

function createWorkOrdersMaterial(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].createWorkOrdersMaterial,
		{
			urlParams: {
				companyId: companyId,
                workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function putWorkOrdersMaterial(companyId, workOrderId, materialId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].putWorkOrdersMaterial,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                materialId: materialId,
			},
			...payload,
		}
	)
}

function patchWorkOrdersMaterial(companyId, workOrderId, materialId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].patchWorkOrdersMaterial,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                materialId: materialId,
			},
			...payload,
		}
	)
}

function deleteWorkOrdersMaterial(companyId, workOrderId, materialId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS_MATERIALS,dtConfig[ModulesMap.WORK_ORDERS_MATERIALS].deleteWorkOrdersMaterial,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
                materialId: materialId,
			},
		}
	)
}

export default {
	getWorkOrdersMaterials,
    getWorkOrdersMaterial,
    createWorkOrdersMaterial,
    putWorkOrdersMaterial,
    patchWorkOrdersMaterial,
    deleteWorkOrdersMaterial,
}

